"use client";
import * as React from "react";
const SvgCodeRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 10", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M5.25 8.26 1.99 5l3.26-3.26a.8.8 0 0 0 0-1.17.8.8 0 0 0-1.17 0L.24 4.41a.83.83 0 0 0 0 1.17l3.84 3.84a.8.8 0 0 0 1.16 0 .8.8 0 0 0 0-1.16m5.51 0L14.01 5l-3.26-3.26a.8.8 0 0 1 0-1.17.8.8 0 0 1 1.17 0l3.84 3.84a.83.83 0 0 1 0 1.17l-3.84 3.84a.8.8 0 0 1-1.17 0 .8.8 0 0 1 0-1.16" }));
export {
  SvgCodeRound as default
};
